import { environment } from 'src/environments/environment';

export const apiurl = {
  referential: {
    getAllOrigins: environment.bff_affectation_server + '/api/v1/referential/coDep',
    getAllDestinations: environment.bff_affectation_server + '/api/v1/referential/coArr',
    getAllCarriers: environment.bff_affectation_server + '/api/v1/referential/coTran',
    findAlldestinationImpc: environment.bff_affectation_server + '/api/v1/referential/destImpc',
    getAirports: environment.bff_affectation_server + '/api/v1/referential/airports',
    getMailSubClass: environment.bff_affectation_server + '/api/v1/referential/mailSubClass',
    getOriginImpc: environment.bff_affectation_server + '/api/v1/referential/originImpc',
    getCountries: environment.bff_affectation_server + '/api/v1/referential/country',
  },
  despatch: {
    findDespatch: environment.bff_appairage_server + '/api/v1/despatchConsign/despatch/',
    findConsignmentContentManuel: environment.bff_appairage_server + '/api/v1/despatchConsign/flashConsignmentContent/',
    findAllConsignmentContentsForManuel: environment.bff_appairage_server + '/api/v1/despatchConsign/allConsignmentContentsForManuel/',
    findDespatchByContentId: environment.bff_appairage_server + '/api/v1/despatch/listDespatchByConsignmentContentId/',
    findDespatchByContainerIdAndNumber: environment.bff_appairage_server + '/api/v1/despatch/listDespatchByContainerIdAndNumber/'
  },
  consignment: {
    findConsignmentByContentId: environment.bff_appairage_server + '/api/v1/consignment/listConsignmentByConsignmentContentId/',
    findConsignmentByContainerId: environment.bff_appairage_server + '/api/v1/consignment/listConsignmentByContainerId/',
    findManualConsignmentByRouteId: environment.bff_appairage_server + '/api/v1/consignment/listManualConsignmentByRouteId/',
    findManualConsignmentByCriteria: environment.bff_appairage_server + '/api/v1/consignment/listManualConsignmentByCriteria',
    findManualConsignmentByConsignmentId: environment.bff_appairage_server + '/api/v1/consignment/manualConsignmentByConsignmentId',
    searchConsignmentByCriteria: environment.bff_appairage_server + '/api/v1/consignment/search',
    getCSVExpeditionByCriteria: environment.bff_appairage_server + '/api/v1/consignment/csv',
    sendManualConsignment: environment.bff_recap_server + '/api/v1/consignment',
    reprintPdf: environment.bff_recap_server + '/api/v1/consignment/reprint',
    cancelConsignment: environment.bff_recap_server + '/api/v1/consignment/cancelManualConsignment/',
    suggestedFlights: environment.bff_recap_server + '/api/v1/consignment/getEquivalentFlights/',
    reassignConsignment: environment.bff_recap_server + '/api/v1/consignment/reassignConsignment/'
  },
  pdf: {
    getPdf: environment.bff_recap_server + '/api/v1/consignment/getPdf/'
  },
  flights: {
    searchByConsignmentContentSearchCriteria: environment.bff_appairage_server + '/api/v1/flights/byConsignmentContentCriteria',
    searchFlights: environment.bff_appairage_server + '/api/v1/flights/',
    completeFlight: environment.bff_recap_server + '/api/v1/flight/completeFlight/',
    reprintTransportDoc: environment.bff_recap_server + '/api/v1/flight/reprintTransportDoc/',
    buildFlightDto: environment.bff_appairage_server + '/api/v1/flights/buildFlightDto/',
    decommissionFlight: environment.bff_recap_server + '/api/v1/flight/decommissionFlight/',
    suggestedFlights: environment.bff_recap_server + '/api/v1/flight/getEquivalentFlights/',
    reassignFlight: environment.bff_recap_server + '/api/v1/flight/reassignFlight/',
    searchRoutes: environment.bff_appairage_server + '/api/v1/flights/routes',
    finalizeRoute: environment.bff_recap_server + '/api/v1/flight/finalizeRoute',
    generatePdfWithQRCode: environment.bff_recap_server + '/api/v1/flight/generatePdfWithQRCode',
    checkIfConsignmentContentCanBeDeleteFromTrajet: environment.bff_appairage_server + '/api/v1/flights/checkIfConsignmentContentCanBeDeletedFromTransport/',
    flashQrCodeOfRoute: environment.bff_appairage_server + '/api/v1/flights/flashQrCodeOfRoute/',
    findRoute: environment.bff_appairage_server + '/api/v1/flights/reloadRoute',
    getRouteGrossWeight: environment.bff_appairage_server + '/api/v1/flights/getGrossWeight'
  },
  container: {
    send: environment.bff_recap_server + '/api/v1/container/send/',
    verifySend: environment.bff_recap_server + '/api/v1/container/verifySend/',
    getContainersByCriteria: environment.bff_appairage_server + '/api/v1/containers/listContainerWithCriteria',
    decommission: environment.bff_recap_server + '/api/v1/container/decommissionContainerFlight/',
    unloadAndReassign: environment.bff_recap_server + '/api/v1/container/unloadAndReassignFlight/',
    suggestedFlights: environment.bff_recap_server + '/api/v1/container/getEquivalentFlights/',
    reassign: environment.bff_recap_server + '/api/v1/container/reassignContainer/',
    unloadContainerTriTCA: environment.bff_recap_server + '/api/v1/container/unloadContainerTriTCA/',
    deleteContainer: environment.bff_recap_server + '/api/v1/container/deleteContainer/',
    checkIfContainerIsAlreadyUsed: environment.bff_appairage_server + '/api/v1/containers/checkIfContainerIsAlreadyUsed/',
    transfertContainer: environment.bff_recap_server + '/api/v1/container/transfertContainer/',
    reprintContainerDoc: environment.bff_recap_server + '/api/v1/container/reprintContainerDocs/',
    addConsignmentContent: environment.bff_recap_server + '/api/v1/container/addConsignmentContent/',
    updateContainerGrossWeight: environment.bff_recap_server + '/api/v1/container/updateContainerWeight/'
  },
  consignmentContent: {
    searchConsignmentContents: environment.bff_appairage_server + '/api/v1/consignmentContents/',
    searchConsignmentContentsByCriteria: environment.bff_appairage_server + '/api/v1/consignmentContents/listConsignmentContentWithCriteria',
    checkIfConsignmentContentCanBeDelete: environment.bff_appairage_server + '/api/v1/consignmentContents/checkIfConsignmentContentCanBeDeleted/',
    deleteConsignmentContents: environment.bff_recap_server + '/api/v1/consignmentContent/unloadConsignmentContentContainer/',
    getConsignmentContentByCab: environment.bff_recap_server + '/api/v1/consignmentContent/getConsignmentContent/',
    unloadConsignmentContents: environment.bff_recap_server + '/api/v1/consignmentContent/unloadConsignmentContents',
    searchConsignmentContentByCabForManual: environment.bff_appairage_server + '/api/v1/consignmentContents/getConsignmentContentForManual/',
    searchConsignmentContentByConsignIdForManual: environment.bff_appairage_server + '/api/v1/consignmentContents/getConsignmentContentsByIdConsignment/',
    addConsignmentContents: environment.bff_recap_server + '/api/v1/consignmentContent/addConsignmentContents',
    deleteConsignmentContentsFromTrajet: environment.bff_recap_server + '/api/v1/consignmentContent/deleteConsignmentContentTrajet/',
    searchConsignmentContentsWithCriteria: environment.bff_appairage_server + '/api/v1/consignmentContents/searchConsignmentContentWithCriteria'

  },
  associations: {
    getAssociationsInfo: environment.bff_appairage_server + '/api/v1/associations/info',
    getAssociationsInfoByCriteria: environment.bff_appairage_server + '/api/v1/associations/search',
    getPlanTriVersion: environment.bff_appairage_server + '/api/v1/associations/version'
  },
  expeditionOpb: {
    getFlights: environment.bff_recap_server + '/services/opb/getFlightsForSortieTca/',
    affectOrUnaffect: environment.bff_recap_server + '/services/opb/affecterDesaffecterSortieTri/'
  },
  csv: {
    getCSVAssociationsInfo: environment.bff_appairage_server + '/api/v1/csv/associations',
    getCSVAssociationsInfoByCriteria: environment.bff_appairage_server + '/api/v1/csv/associations/criteria',
    getCsvExtractContainers: environment.bff_appairage_server + '/api/v1/csv/extractContainers',
    getCsvSortings: environment.bff_appairage_server + '/api/v1/csv/sortings',
    getCsvConsignmentContents: environment.bff_appairage_server + '/api/v1/csv/extractConsignmentContents'
  },
  i2a: {
    complementarityDataForExternalUser: environment.bff_appairage_server + '/api/v1/user/complementarityData'
  },
  extracontainer: {
    getExtraContainer: environment.bff_appairage_server + '/api/v1/modelecontenant/availableModels',
  }
};
